/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getRouteInteractionMode, isAllModesPath } from '@/lib/interactionExperience';
import FocusChatRoom from './Room/FocusChatRoom';
import Antechamber from './Antechamber';
import Room from './Room';
import { RootState } from '@/store';

function MainArea() {
  const room = useSelector((state: RootState) => state.room);
  const { interactionMode } = room;
  const location = useLocation();
  const allowAllModes = isAllModesPath(location.pathname);
  const routeInteractionMode = getRouteInteractionMode(location.pathname);
  const rawInteractionMode = allowAllModes
    ? interactionMode || routeInteractionMode
    : 'smart_assistant';
  // Room and FocusChatRoom mount separately; carry the active voice session across.
  const previousMode = useRef(rawInteractionMode);
  const resumeVoiceCall =
    previousMode.current === 'immersive' && room.isJoined && room.isAIGCEnable;
  useEffect(() => {
    previousMode.current = rawInteractionMode;
  }, [rawInteractionMode]);
  const isDesktopCompanionMode = rawInteractionMode === 'desktop_companion';
  if (rawInteractionMode === 'immersive') {
    return room.isJoined ? <Room /> : <Antechamber />;
  }
  return (
    <FocusChatRoom
      desktopCompanion={isDesktopCompanionMode}
      initialVoiceCallModeEnabled={resumeVoiceCall}
    />
  );
}

export default MainArea;
